import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { EnvironmentService } from '../services/environment.service';

/**
 * Rewrites relative-prefixed URLs (`/bhive/...`, `/supergod/...`) into
 * absolute URLs against the active region's backend.
 *
 * Note: the rest of the codebase builds absolute URLs directly off
 * `EnvironmentService.<urlKey>` (e.g. `${this.env.supergodUrl}/foo`), so this
 * interceptor is mostly a forward-compatibility hook. Absolute URLs (anything
 * starting with `http`) pass through unchanged.
 */
export const environmentInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  const env = inject(EnvironmentService);
  const rewritten = rewriteUrl(req.url, env);
  if (rewritten === req.url) {
    return next(req);
  }
  return next(req.clone({ url: rewritten }));
};

function rewriteUrl(url: string, env: EnvironmentService): string {
  if (url.startsWith('/bhive')) {
    return env.bhiveUrl + url.slice('/bhive'.length);
  }
  if (url.startsWith('/supergod')) {
    return env.supergodUrl + url.slice('/supergod'.length);
  }
  return url;
}
